// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__wy7jh","row":"classes_row__3fnaU","cell":"classes_cell__18IZX","sort-icon":"classes_sort-icon__1JqrW","background":"classes_background__1V_oB"};